module.exports = __webpack_public_path__ + "img/hero-shape-small.6a411fd1.svg";